export default "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAABCAYAAACc0f2yAAAAAXNSR0IArs4c6QAAABBJREFUCB1jZJJz+M8wDAAAED4BYWNWrFIAAAAASUVORK5CYII="